const concurrent_device_limit = {
    title: 'Ограничение на количество одновременных устройств',
    enable: 'Включить ограничение на количество одновременных устройств',
    enable_description: 'Когда включено, Logto применяет максимальное количество активных грантов на пользователя для этого приложения.',
    field: 'Ограничение на количество одновременных устройств на приложение',
    field_description: 'Ограничьте количество устройств, на которые пользователь может войти одновременно. Logto применяет это, ограничивая количество активных грантов и автоматически отзывает самый старый грант, когда лимит превышен.',
    field_placeholder: 'Оставьте пустым для отсутствия ограничений',
    should_be_greater_than_zero: 'Должно быть больше 0.',
};
export default Object.freeze(concurrent_device_limit);
